import React, { useContext, useEffect, useState } from 'react';
import { Breadcrumb, Button, OverlayTrigger } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { BiChevronLeft, BiChevronRight, BiPlus } from 'react-icons/bi';
import { BsChevronRight, BsChevronLeft } from 'react-icons/bs';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { EventContext, LoaderContext, RegulationContext } from '../../../../App';
import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal';
import Pagination from "../../../../components/Pagination/Pagination";
import { DEFAULT_ITEMS_PER_PAGE, EventType, FormType, LS_ACTIVE_ASSESSMENT_LIST_KEY, LS_SELECTED_MAT_ISSUE_YEAR, SORT_ORDER_DESC, currentYear, startYear } from '../../../../core/constants/common';
import FormService from '../../../../core/service/FormService';
import MatAssessmentService from '../../../../core/service/MatAssessmentService';
import Utils from '../../../../core/utilities/Utils';
import assessment_pic from "../../../../images/Assessment.png";
import AssessmentListCard from '../AssessmentList/AssessmentListCard';
import AssessmentReminderModal from '../AssessmentList/AssessmentReminderModal';
import AssessmentReshareModal from '../AssessmentList/AssessmentReshareModal';
import MatAssessmentModal from './MatAssessmentModal';
import './MaterialityAssessment.scss';
import useHasPermission from '../../../../core/hooks/useHasPermission';

const MatAssessmentList = ({ t }) => {
	const [searchParams] = useSearchParams();
	const [loadConfirmShareModal, setLoadConfirmShareModal] = useState(false);
	const { hasDoubleMaterialityUpdatePermission } = useHasPermission();
	const { glbRegulation } = useContext(RegulationContext);
	const glbRegulationId = glbRegulation?.id ? glbRegulation.id : "";
	const [itemsTotalCount, setItemTotalCount] = useState(0);
	const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_ITEMS_PER_PAGE);
	const [currentPage, setCurrentPage] = useState(1);
	const [assessments, setAssessments] = useState([])
	const [sharedAssId, setSharedAssId] = useState(0);
	const [permBubble, setPermBubble] = useState(false)
	const { loaderDisplay, setLoaderDisplay } = useContext(LoaderContext);
	const [sortField, setSortField] = useState('createdDate');
	const [order, setOrder] = useState(SORT_ORDER_DESC);
	const lsSelfValue = localStorage.getItem(LS_ACTIVE_ASSESSMENT_LIST_KEY);
	const [selfAssessment, setSelfAssessment] = useState(lsSelfValue ? lsSelfValue === 'self' : true);
	const [quickRemindAssmtId, setQuickRemindAssmtId] = useState(0);
	const [remindedAssessmentId, setRemindedAssessmentId] = useState(0);
	const [lastSubmissionDate, setLastSubmissionDate] = useState(null);
	const location = useLocation();
	// Reopened when coming back from the reshare dialog's "Go to permission"
	const [assessmentToReshare, setAssessmentToReshare] = useState(location?.state?.reshareAssessment ?? { id: 0 });
	const navigate = useNavigate();
	const { setEvent } = useContext(EventContext);
	const selectedYear = localStorage.getItem(LS_SELECTED_MAT_ISSUE_YEAR) ?? null;
	const year = new Date().getFullYear();
	const yearOptions = [];
	for (let i = currentYear; i >= startYear; i--) {
		yearOptions.push(<option value={i} key={i}>{i}</option>);
	};
	const [filter, setFilter] = useState({
			year: searchParams.get('year') ?? selectedYear ?? `${year}`
	});
	const [editedAssId, setEditedAssId] = useState(searchParams.get('openNew') === 'true' ? 0 : -1);
	
	

	useEffect(() => {
		localStorage.setItem(LS_SELECTED_MAT_ISSUE_YEAR, filter.year);
		getAssessments(0, itemsPerPage, sortField, order,filter.year);
	}, [filter]);

	const getAssessments = (pageNumber, itemsPerPageVal, sortField, orderVal,year) => {
		if (pageNumber > 0) {
			pageNumber = pageNumber - 1;
		} else {
			setCurrentPage(1);
		}
		const perPage = itemsPerPageVal > 0 ? itemsPerPageVal : itemsPerPage;
		const sort = sortField + "," + orderVal;
		setLoaderDisplay(true);

		FormService.listAssessments(
			pageNumber,
			perPage,
			'',
			sort,
			'',
			true,
			true,
			'SURVEY',
			year
		).then((response) => {
			setLoaderDisplay(false);
			setItemTotalCount(parseFloat(response.headers["x-total-count"]));
			setAssessments([...response.data]);
		}).catch((error) => { setLoaderDisplay(false); });
	};

	const onShareAssessment = (confirmed) => {
		if (!confirmed) {
			setLoadConfirmShareModal(false);
			setSharedAssId(0);
			return;
		}
		MatAssessmentService.share(sharedAssId).then(res => {
			setSharedAssId(0);
			setLoadConfirmShareModal(false);
			if (res.status !== 200) return;

			toast.success(t('SurveySharedSuccessMsg.label'), {
				position: toast.POSITION.TOP_RIGHT,
			});
			getAssessments(currentPage, itemsPerPage, sortField, order,filter.year)
		}).catch((error) => { setSharedAssId(0); });
	};

	const blankCardToRender = () => {
		return (
			<div className="Assessment_blankcard">
				<div>
					<div className="assessment_pic">
						<img src={assessment_pic} />
					</div>
					<h4 className="mb-4">{t('MatAssessmentBlankHeader.label')}</h4>
					<Button variant="primary" className="px-3" hidden={!hasDoubleMaterialityUpdatePermission()} onClick={() => setEditedAssId(0)}>
						<BiPlus className="mr-2" /> {t("New.label")}
					</Button>
				</div>
			</div>
		);
	};

	const headerToRender = () => {
		return (
			<div className="List_header">
				<Breadcrumb className='h5'>
					<Breadcrumb.Item onClick={() => navigate(`/company_admin/dmat/stats`)}>{t("Materiality.label")}</Breadcrumb.Item>
					<Breadcrumb.Item active>{t("Surveys.label")}</Breadcrumb.Item>
				</Breadcrumb>
				
				<div className="d-flex justify-content-end align-items-center header-actions">
				<select className="form-select  w-auto form-select-sm" value={filter.year} 
					onChange={(e) => { 
						setFilter({ ...filter, year: e.target.value }); 
						setEvent({
							event: EventType.DOUBLE_MAT_YEAR_CHANGED,
							data: { year: e.target.value},
						});
					}}>
                    {yearOptions}
                </select>
					<Button variant="primary" className='btn-sm'  hidden={!hasDoubleMaterialityUpdatePermission()} onClick={() => {
						setEditedAssId(0);
					}}>
						<BiPlus className="me-1" />
						{t("New.label")}
					</Button>

					<OverlayTrigger placement="top" overlay={Utils.renderTooltip(t("NavigateBackAndNext.MatIssues"))}>
						<Button variant='secondary' className='back-btn btn-sm scorecard-btn' onClick={() => navigate(`/company_admin/dmat/issues`)}>
							<BsChevronLeft /> <span>{t("Back.label")}</span>
						</Button>
					</OverlayTrigger>
					<OverlayTrigger placement="top" overlay={Utils.renderTooltip(t("NavigateBackAndNext.Scorecard"))}>
						<Button variant='secondary' className='next-btn btn-sm scorecard-btn' onClick={() => navigate(`/company_admin/dmat/scorecard/default`)}>
							<span>{t("Next.label")}</span> <BsChevronRight />
						</Button>
					</OverlayTrigger>

				</div>
			</div>
		);
	};


	const onSendReminder = (confirmed) => {
		if (!confirmed) {
			setQuickRemindAssmtId(0);
			return;
		}
		FormService.sendReminder(quickRemindAssmtId).then(res => {
			if (res.status !== 200) return;

			toast.success("Success", {
				position: toast.POSITION.TOP_RIGHT,
			});
			setQuickRemindAssmtId(0);
		}).catch((error) => { });
	};

	const confirmShareModalRender = () => {
			return (
		<ConfirmationModal
			modalShow={true}
			title={t('ShareSurvey.label')}
			messageText={t("AssessmentShareConfirmMessage.label")}
			callbackModal={(val) => onShareAssessment(val)}
			confirmBtn={t("Share.label")}
			CancelBtn={t("DoItLater.label")}
		/>)
		}
	

	// Drop the one-time reshare reopen from the route state so a refresh does not reopen the dialog
	useEffect(() => {
		if (!location?.state?.reshareAssessment) return;

		const { reshareAssessment, ...state } = location.state;
		navigate(`${location.pathname}${location.search}`, { replace: true, state: state });
	}, []);

	return (
		<>
			<div className="FormsList">
				{headerToRender()}
				<div className="List_Table_01 mt-2">
					<div className='Assessment_Company'>
						{(!loaderDisplay || editedAssId >= 0) && assessments.length === 0 && blankCardToRender()}
						{
							(!loaderDisplay || editedAssId >= 0) && assessments.length > 0 &&
							<div className='Assessment_Company_listbox'>
								{
									assessments.map((form, index) => {
										return <AssessmentListCard key={`assessment-form-card-${index + 1}`}
											form={form}
											formType={FormType.SURVEY}
											selfAssessment={true}
											onPermBubbleClick={() => {
												setEditedAssId(form.id);
												setPermBubble(true);
											}}
											onShareClick={() => {
												setSharedAssId(form.id);
											}}
											onReshareClick={() => {
												setAssessmentToReshare(form);
											}}
											onQuickRemindClick={() => setQuickRemindAssmtId(form.id)}
											onEditAssessment={() => setEditedAssId(form.id)}
											onReminderSetup={() => {
												setRemindedAssessmentId(form.id);
												setLastSubmissionDate(form.lastSubmissionDate);
											}}
										/>
									})
								}
							</div>
						}
					</div>
					{
						assessments?.length > 0 &&
						<div className="p-2 List_footer_count">
							<Pagination
								itemsTotalCount={itemsTotalCount}
								itemsPerPage={itemsPerPage}
								currentPage={currentPage}
								setCurrentPage={setCurrentPage}
								alwaysShown={true}
								setItemsPerPage={setItemsPerPage}
								pageClicked={(pageNum, perPage) => {
									getAssessments(pageNum, perPage, sortField, order,filter.year);
								}}
							/>
						</div>
					}
				</div>
			</div >
			{
				editedAssId >= 0 &&
				<MatAssessmentModal
					id={editedAssId}
					onSave={() => {
						sharedAssId > 0 && setLoadConfirmShareModal(true)
						getAssessments(0, itemsPerPage, sortField, order,filter.year)
					}}
					onHide={() => {
						setEditedAssId(-1);
						setPermBubble(false);
					}}
					enablePermCard={permBubble}
					onShareAssessment={(val) => onShareAssessment(val)}
				/>
			}
			{
				loadConfirmShareModal && confirmShareModalRender()
			}
			{
				sharedAssId > 0 &&
				<ConfirmationModal
					modalShow={true}
					title={t('ShareSurvey.label')}
					messageText={t('SurveyShareConfirmMessage.label')}
					callbackModal={(val) => onShareAssessment(val)}
					confirmBtn={t("Confirm.label")}
					CancelBtn={t("Cancel.label")}
				/>
			}
			{
				quickRemindAssmtId > 0 &&
				<ConfirmationModal
					modalShow={true}
					title={t('SendReminder2.label')}
					messageText={t('QuickSendReminderConfForStakeholders.label')}
					callbackModal={(val) => onSendReminder(val)}
					confirmBtn={t("Yes.label")}
					CancelBtn={t("No.label")}
				/>
			}
			{
				remindedAssessmentId > 0 &&
				<AssessmentReminderModal id={remindedAssessmentId}
					formType={FormType.SURVEY}
					onHide={(saved) => {
						setRemindedAssessmentId(0);
						if (!saved) return;

						getAssessments(currentPage, itemsPerPage, sortField, order,filter.year);
					}}
					lastSubmissionDate={lastSubmissionDate} />
			}
			{
				assessmentToReshare?.id > 0 &&
				<AssessmentReshareModal assessment={assessmentToReshare}
					selfAssessment={selfAssessment}
					formType={FormType.SURVEY}
					onHide={() => setAssessmentToReshare({ id: 0 })}
					onSuccess={() => {
						setAssessmentToReshare({ id: 0 });
						getAssessments(currentPage, itemsPerPage, sortField, order,filter.year);
					}}
				/>

			}
		</>
	);
};

export default withTranslation()(MatAssessmentList);